var _rect, _mask, _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdatePlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 63,
    viewBox: "0 0 75 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    width: 76,
    height: 63,
    fill: "#002687"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1704_31179",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7 21C22.7 19.3431 24.0431 18 25.7 18H49.7C51.3568 18 52.7 19.3431 52.7 21V35C52.7 36.6569 51.3568 38 49.7 38H40.7V44C40.7 44.1012 40.695 44.2013 40.6852 44.3H53.7C54.0866 44.3 54.4 44.6134 54.4 45C54.4 45.3866 54.0866 45.7 53.7 45.7H40.1722C39.6312 46.4853 38.7257 47 37.7 47C36.6743 47 35.7688 46.4853 35.2278 45.7H21.7C21.3134 45.7 21 45.3866 21 45C21 44.6134 21.3134 44.3 21.7 44.3H34.7148C34.705 44.2013 34.7 44.1012 34.7 44V38H25.7C24.0431 38 22.7 36.6569 22.7 35V21Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7 38V36.3H39V38H40.7ZM40.6852 44.3L38.9935 44.132L38.808 46H40.6852V44.3ZM40.1722 45.7V44H39.279L38.7723 44.7355L40.1722 45.7ZM35.2278 45.7L36.6277 44.7355L36.121 44H35.2278V45.7ZM34.7148 44.3V46H36.592L36.4065 44.132L34.7148 44.3ZM34.7 38H36.4V36.3H34.7V38ZM25.7 16.3C23.1042 16.3 21 18.4043 21 21H24.4C24.4 20.282 24.982 19.7 25.7 19.7V16.3ZM49.7 16.3H25.7V19.7H49.7V16.3ZM54.4 21C54.4 18.4043 52.2957 16.3 49.7 16.3V19.7C50.418 19.7 51 20.282 51 21H54.4ZM54.4 35V21H51V35H54.4ZM49.7 39.7C52.2957 39.7 54.4 37.5957 54.4 35H51C51 35.718 50.418 36.3 49.7 36.3V39.7ZM40.7 39.7H49.7V36.3H40.7V39.7ZM42.4 44V38H39V44H42.4ZM42.3769 44.468C42.3922 44.3136 42.4 44.1574 42.4 44H39C39 44.0451 38.9978 44.0891 38.9935 44.132L42.3769 44.468ZM40.6852 46H53.7V42.6H40.6852V46ZM53.7 46C53.1477 46 52.7 45.5523 52.7 45H56.1C56.1 43.6745 55.0255 42.6 53.7 42.6V46ZM52.7 45C52.7 44.4477 53.1477 44 53.7 44V47.4C55.0255 47.4 56.1 46.3255 56.1 45H52.7ZM53.7 44H40.1722V47.4H53.7V44ZM37.7 48.7C39.3084 48.7 40.7274 47.8905 41.5721 46.6645L38.7723 44.7355C38.5349 45.08 38.143 45.3 37.7 45.3V48.7ZM33.8279 46.6645C34.6726 47.8905 36.0916 48.7 37.7 48.7V45.3C37.257 45.3 36.8651 45.08 36.6277 44.7355L33.8279 46.6645ZM35.2278 44H21.7V47.4H35.2278V44ZM21.7 44C22.2523 44 22.7 44.4477 22.7 45H19.3C19.3 46.3255 20.3745 47.4 21.7 47.4V44ZM22.7 45C22.7 45.5523 22.2523 46 21.7 46V42.6C20.3745 42.6 19.3 43.6745 19.3 45H22.7ZM21.7 46H34.7148V42.6H21.7V46ZM33 44C33 44.1574 33.0078 44.3136 33.0231 44.468L36.4065 44.132C36.4022 44.0891 36.4 44.0451 36.4 44H33ZM33 38V44H36.4V38H33ZM25.7 39.7H34.7V36.3H25.7V39.7ZM21 35C21 37.5957 23.1043 39.7 25.7 39.7V36.3C24.982 36.3 24.4 35.718 24.4 35H21ZM21 21V35H24.4V21H21Z",
    fill: "white",
    mask: "url(#path-2-inside-1_1704_31179)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.7002,
    cy: 19,
    r: 2.3,
    fill: "#072164",
    stroke: "white",
    strokeWidth: 1.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.7002,
    cy: 19,
    r: 2.3,
    fill: "#072164",
    stroke: "white",
    strokeWidth: 1.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.7002,
    cy: 19,
    r: 2.3,
    fill: "#072164",
    stroke: "white",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatePlan);
export default __webpack_public_path__ + "static/media/updatePlan.5f8c9f55a1cc30afcba2b83d5e3cd0a0.svg";
export { ForwardRef as ReactComponent };